import { useState } from "react";
import useDocumentScrollThrottled from "./windowScrollListener";

import Logo from "./Logo";
import NavigationItems from "./NavigationItems";

import DropDown from "./DropDown";
import "./css/Header.css";

const Header = () => {
    const [showDropDown, setShowDropDown] = useState(false);
    const [shouldHideHeader, setShouldHideHeader] = useState(false);

    const MINIMUM_SCROLL = 100;
    const TIMEOUT_DELAY = 150;

    useDocumentScrollThrottled((callbackData) => {
        const { previousScrollTop, currentScrollTop } = callbackData;
        const isScrolledDown = previousScrollTop < currentScrollTop;
        const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL;

        setTimeout(() => {
            setShouldHideHeader(isScrolledDown && isMinimumScrolled);
            setShowDropDown((prevVal) => {
                if (prevVal === false) return;
                else if (shouldHideHeader === true) return false;
            });
        }, TIMEOUT_DELAY);
    });

    const hiddenStyle = shouldHideHeader ? "-translate-y-20" : "translate-y-0";

    return (
        <header
            className={`z-50 transition-transform duration-400 transform ${hiddenStyle} fixed top-0 left-0 right-0`}
            id="bg-blur-medium"
        >
            <div className="section-size">
                <div className="z-50 flex justify-between h-full py-2 md:py-4  px-6 sm:px-10">
                    <Logo />
                    <div className="hidden md:block">
                        <NavigationItems dropDownHandler={setShowDropDown} />
                    </div>
                    <div className="block items-center md:hidden">
                        {/* Mobile menu button */}
                        <button
                            aria-label="Menu"
                            type="button"
                            className="inline-flex items-center justify-center p-2 text-content-color hover:text-main focus:outline-none"
                            aria-controls="mobile-menu"
                            aria-expanded="false"
                            onClick={() =>
                                setShowDropDown((prevVal) => !prevVal)
                            }
                        >
                            <div className="h-10 w-10">
                                <svg
                                    className={
                                        "hamburger " +
                                        (showDropDown ? "active" : "")
                                    }
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="20 20 60 60"
                                    stroke="currentColor"
                                >
                                    <path
                                        className="line-1"
                                        d="M0 40h62c13 0 6 28-4 18L35 35"
                                    />
                                    <path className="line-2" d="M0 50h70" />
                                    <path
                                        className="line-3"
                                        d="M0 60h62c13 0 6-28-4-18L35 65"
                                    />
                                </svg>
                            </div>
                        </button>
                    </div>
                </div>
                <DropDown
                    open={showDropDown}
                    dropDownHandler={setShowDropDown}
                />
            </div>
        </header>
    );
};

export default Header;
